/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    ClientId,
    ClientSecret,
    GrantType,
    HTTPValidationError,
    UserModelResponse,
} from '../models/index';
import {
    ClientIdFromJSON,
    ClientIdToJSON,
    ClientSecretFromJSON,
    ClientSecretToJSON,
    GrantTypeFromJSON,
    GrantTypeToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    UserModelResponseFromJSON,
    UserModelResponseToJSON,
} from '../models/index';

export interface LoginApiV1UserLoginPostRequest {
    username: string;
    password: string;
    grantType?: GrantType;
    scope?: string;
    clientId?: ClientId;
    clientSecret?: ClientSecret;
}

/**
 *
 */
export class UserApi extends runtime.BaseAPI {
    /**
     * Get All Users
     */
    async getAllUsersApiV1UserAllGetRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<UserModelResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/user/all`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(UserModelResponseFromJSON),
        );
    }

    /**
     * Get All Users
     */
    async getAllUsersApiV1UserAllGet(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<UserModelResponse>> {
        const response = await this.getAllUsersApiV1UserAllGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Login
     */
    async loginApiV1UserLoginPostRaw(
        requestParameters: LoginApiV1UserLoginPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError(
                'username',
                'Required parameter "username" was null or undefined when calling loginApiV1UserLoginPost().',
            );
        }

        if (requestParameters['password'] == null) {
            throw new runtime.RequiredError(
                'password',
                'Required parameter "password" was null or undefined when calling loginApiV1UserLoginPost().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [{ contentType: 'application/x-www-form-urlencoded' }];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['grantType'] != null) {
            formParams.append(
                'grant_type',
                new Blob([JSON.stringify(GrantTypeToJSON(requestParameters['grantType']))], {
                    type: 'application/json',
                }),
            );
        }

        if (requestParameters['username'] != null) {
            formParams.append('username', requestParameters['username'] as any);
        }

        if (requestParameters['password'] != null) {
            formParams.append('password', requestParameters['password'] as any);
        }

        if (requestParameters['scope'] != null) {
            formParams.append('scope', requestParameters['scope'] as any);
        }

        if (requestParameters['clientId'] != null) {
            formParams.append(
                'client_id',
                new Blob([JSON.stringify(ClientIdToJSON(requestParameters['clientId']))], {
                    type: 'application/json',
                }),
            );
        }

        if (requestParameters['clientSecret'] != null) {
            formParams.append(
                'client_secret',
                new Blob([JSON.stringify(ClientSecretToJSON(requestParameters['clientSecret']))], {
                    type: 'application/json',
                }),
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/user/login`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            },
            initOverrides,
        );

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Login
     */
    async loginApiV1UserLoginPost(
        requestParameters: LoginApiV1UserLoginPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<any> {
        const response = await this.loginApiV1UserLoginPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
